import React, { PureComponent } from 'react';

import { ThemeContext } from 'utils/theme';

import Wrapper from './styled/Wrapper';
import MediaWrapper from './styled/MediaWrapper';
import Img from './styled/Img';
import Video from './styled/Video';

export default class HeroSection extends PureComponent {
  static defaultProps = {};

  static contextType = ThemeContext;

  render() {
    const { className, url } = this.props;

    if (!url?.length) return null;

    const Image = <Img src={url} />;

    const VideoComp = <Video muted autoPlay controls src={url} />;

    const MediaComponent = /\.(mp4|mov|avi|mkv|wmv)$/i.test(url)
      ? VideoComp
      : Image;

    return (
      <Wrapper className={className} theme={this.context}>
        <MediaWrapper>
          {MediaComponent}
        </MediaWrapper>
      </Wrapper>
    );
  }
}
